import * as React from 'react';
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import './assignedEndpoints.css'
import Modal from "react-responsive-modal";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface State {
    columnDefs: any;
    gridApi: any;
    columnApi: any;
    selectedRoute: any;
    rowData: any
}

interface Props {
    showModal: boolean
    hideModal(): void,
    apiEndPoints: any
    uiRoutes: any
}

class AssignedEndpointsAndRoutes extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [],
            gridApi: null,
            columnApi: null,
            selectedRoute: null,
            rowData: []
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
            this.buildGrid();
        }
    }

    buildGrid = () => {
        let rowData = [];
        let columnDefs = [];
        if (this.props.uiRoutes && !this.props.apiEndPoints) {
            rowData = this.props.uiRoutes.value.map(route => {
                return {
                    uiRoute: route
                }
            })
            columnDefs = [
                {
                    field: "uiRoute",
                    headerName: 'UI Route',
                    tooltipField: 'UI Route',
                    headerTooltip: 'UI Route',
                    type: 'text',
                },
            ]
        } else if (this.props.apiEndPoints && !this.props.uiRoutes) {
            rowData = this.props.apiEndPoints.value;
            columnDefs = [
                {
                    id: "",
                    headerName: "ID",
                    field: "id",
                    headerTooltip: "id",
                    type: 'text',
                    width: 110,
                    suppressSizeToFit: true,
                    hide: true,
                    lockVisible:  true,
                },
                {
                    field: 'method',
                    headerName: "Method",
                    tooltipField: 'Method',
                    headerTooltip: "Method",
                    type: 'text',
                    width: 110,
                    maxWidth: 110
                },
                {
                    field: 'url',
                    headerName: "URL",
                    tooltipField: 'URL',
                    headerTooltip: "URL",
                    type: 'text',
                },

                // {
                //     field: 'actions',
                //     headerName: "Action",
                //     tooltipField: 'Action',
                //     headerTooltip: "Action",
                //     sortable: false,
                //     filter: false,
                //     width: 60,
                //     floatingFilter: false,
                //     cellRenderer: (params: any) => {
                //         const eDiv = document.createElement('div');
                //         eDiv.innerHTML = `<button id="delete-ui-route" style="padding: 2px 6px;" class="btn btn-danger">Delete</button>`
                //
                //         const eButtonUsersAllowed = eDiv.querySelectorAll('#delete-ui-route')[0];
                //         eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%; justify-content: center; padding: 3px 0 3px 0';
                //
                //         eButtonUsersAllowed.addEventListener('click', (event) => {
                //             event.stopImmediatePropagation();
                //             this.onDeleteHandler(params.data.id);
                //         });
                //
                //         return eDiv;
                //     }
                // },
            ]
        }

        this.setState({
            columnDefs: columnDefs,
            rowData: rowData
        })
    }

    close = () => {
        this.props.hideModal();
    };

    onGridReady = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
        })
    }

    generateModalHeader = () => {
        if (this.props.uiRoutes && !this.props.apiEndPoints) {
            return this.props.uiRoutes.data.functionalityName + ' - UI Routes';
        }
        if (!this.props.uiRoutes && this.props.apiEndPoints) {
            return this.props.apiEndPoints.data.functionalityName + ' - API Endpoints';
        }
        return '';
    }

    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: '650px',
                        padding: 0,
                        maxWidth: '650px',
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}} className={'access-control-grid'}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'manage-ui-routes-modal-header'}>
                                <h2>{this.generateModalHeader()}</h2>
                            </header>
                            <div className={'manage-ui-routes-modal-container'}>
                                <div style={{width: '100%', margin: 10, height: 645}}
                                     className={"ag-theme-balham-dark ag-grids"}>
                                    <header className={'instance-layout-grid-header'}>
                                        <h5>{this.props.uiRoutes ? 'UI Routes' : this.props.apiEndPoints ? 'API Endpoints' : ''}</h5>
                                    </header>
                                    <AgGridReact
                                        onGridReady={this.onGridReady}
                                        onFirstDataRendered={this.onGridReady}
                                        columnDefs={this.state.columnDefs}
                                        rowData={this.state.rowData}
                                        defaultColDef={{
                                            minWidth: 100,
                                            flex: 1,
                                            filter: "agTextColumnFilter",
                                            floatingFilter: true,
                                            sortable: true,
                                            filterParams: {
                                                filterOptions: ['contains'],
                                                applyButton: false,
                                                clearButton: false,
                                                suppressAndOrCondition: false
                                            },
                                            autoHeight: true,
                                            resizable: true,
                                        }}
                                        gridOptions={{
                                            suppressDragLeaveHidesColumns: true,
                                            floatingFilter: true,
                                            suppressRowClickSelection: true,
                                            suppressCellSelection: true
                                        }}
                                    >
                                    </AgGridReact>
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default AssignedEndpointsAndRoutes



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/FunctionalitiesGrid/components/uiRotesAndEndpointsModal/AssignedEndpointsAndRoutes.tsx